import AccessTokenStore from '../../lib/accessTokenStore'
import AuthClient from '../../lib/authClient'
import reportAuthFailure from '../../lib/reportAuthFailure'

const HANDOFF_PATH = 'auth/token'


/**
 * Trades the one-time handoff cookie for an access token and stores it.
 *
 * @returns {Promise} resolves once the attempt is over, whether or not a token
 *   was collected, and rejects only if reporting a failure throws
 */
export default async function consumeHandoff() {
  try {
    const { data } = await AuthClient.get(HANDOFF_PATH)

    AccessTokenStore.setAccessToken({
      accessToken: data.access_token,
      expiresIn: data.expires_in,
    })
  } catch (error) {
    // A refusal means the marker promised a handoff that is no longer there to
    // collect. The two cookies carry the same lifetime but are cleared
    // independently, so a readable marker can outlive its key, and the server
    // spends the key the moment it is read.
    reportAuthFailure(error)
  }
}
